module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_nia_m2.aba26f24ba64a728994143652e2b4779.png";